import {IVessel} from "../../varibles/interface";
import {createSliceSelectors} from "../selectors";

export const NAME_SLICE = 'vessel'

export interface VesselState {
    data: IVessel[]
    loading: boolean

    vesselContracts: {
        data: IVessel[],
        loading: boolean
    }
}

export const initialState: VesselState = {
    data: [],
    loading: false,

    vesselContracts: {
        data: [],
        loading: false
    },
}

export const selectVessel = createSliceSelectors(NAME_SLICE, initialState);
